module.exports = __webpack_public_path__ + "img/VP-ECONew_Overview-EVA_2.408f3753.jpg";